export default {
  SET_NAV_TOP_MENU: 'SET_NAV_TOP_MENU',
  SET_NAV_LEFT_MENU: 'SET_NAV_LEFT_MENU',
  SET_REGION: 'SET_REGION',
  SET_SELECTED_REGION_ID: 'SET_SELECTED_REGION_ID',
  SET_IS_SHOW_REGION_SELECT: 'SET_IS_SHOW_REGION_SELECT',
  SET_IS_CREATE_PAGE: 'SET_IS_CREATE_PAGE',
  SET_USER_INFO: 'SET_USER_INFO',
  SET_ACCOUNT_REMAINDER: 'SET_ACCOUNT_REMAINDER',
  SET_MESSAGE_COUNT: 'SET_MESSAGE_COUNT',
  SET_UNREAD_MESSAGE: 'SET_UNREAD_MESSAGE',
  SET_PENDING_ORDER: 'SET_PENDING_ORDER'
}
